import { useTranslation } from "react-i18next";
import { z } from "zod";

export const emailSchema = z.object({
  login_id: z.string().email("올바른 이메일 형식이 아닙니다."),
});

export const joinSchema = (isSocialLogin: boolean) =>
  z
    .object({
      name: z.string().min(1, ""),
      country: z.string().min(1, ""),
      // postcode: z.string().min(1, ""),
      // address: z.string().min(1, ""),
      nickname: z.string().min(1, "").max(10, "").regex(/^[^!@#$%^&*()_+=\-\[\]\{\};"'|\\/<>,.?~`]+$/, ""),
      isNicknameUnique: z.boolean(),

      // 소셜 로그인인 경우 비밀번호 검사 없이 넘어가도록 처리
      password: isSocialLogin
        ? z.string().nullable() // 소셜 로그인일 때는 password 검사를 하지 않음
        : z
            .string()
            .min(8)
            .max(20)
            .regex(/^(?=.*[a-zA-Z])(?=.*\d)/),

      // 소셜 로그인인 경우 비밀번호 확인 검사 없이 넘어가도록 처리
      passwordConfirm: isSocialLogin
        ? z.string().nullable() // 소셜 로그인일 때는 passwordConfirm 검사를 하지 않음
        : z.string(),
    })
    .passthrough()
    .refine(
      (data) => {
        // 소셜 로그인인 경우 passwordConfirm을 체크하지 않음
        if (!isSocialLogin) {
          return data.password === data.passwordConfirm;
        }
        return true; // 소셜 로그인인 경우는 항상 true로 리턴
      },
      {
        message: "",
        path: ["passwordConfirm"],
      },
    );

export const loginSchema = z.object({
  login_id: z.string().email("이메일 형식이 맞지 않습니다."),
  password: z.string(),
});

export const passwordSchema = z
  .object({
    findemail: z.string().email("올바른 이메일 형식이 아닙니다."),
    newpassword: z
      .string()
      .min(8, "")
      .max(20, "")
      .regex(/^(?=.*[a-zA-Z])(?=.*\d)/, ""),
    newpasswordConfirm: z.string(),
  })
  .refine((data) => data.newpassword === data.newpasswordConfirm, {
    message: "",
    path: ["newpasswordConfirm"],
  });

export const profileEditSchema = z
  .object({
    name: z.string().min(1, ""),
    country: z.string().min(1, ""),
    // postcode: z.string().min(1, ""),
    // address: z.string().min(1, ""),
    nickname: z.string().min(1, "").max(10, "").regex(/^[^!@#$%^&*()_+=\-\[\]\{\};"'|\\/<>,.?~`]+$/, "")
    .optional(),
  })
  .passthrough();


  export const productEditSchema = (t : any) => z
  .object({
    name_ko: z.string().min(1, t("상품명을 입력해주세요.")),
    // brand_id: z.number().min(1, t("브랜드를 선택해주세요.")),
    brand_id: z.number().nullable().refine(val => val && val > 0, "브랜드를 선택해주세요."),

    product_condition: z.string().min(1, t("상품의 컨디션을 선택해주세요.")),
    price: z.number().min(1000,t("판매가격을 입력해주세요.")),
    description_ko: z.string().min(1, t("상품 설명을 입력해주세요.")),
    image_list: z.array(z.string()).nonempty(t("상품 사진을 등록해주세요.")),
    
    stock_list: z.array(
      z.object({
        color_id: z.number().min(1),
        size_list: z.array(
          z.object({
            size_id: z.number().min(1),
            amount: z.number().min(1)
          })
        ).nonempty() // size_list 빈 배열 허용하지 않음
      })
    ).nonempty() // stock_list 빈 배열 허용하지 않음
    
  })
  .passthrough();

export const productSchema = (t : any) =>z
  .object({
    name_ko: z.string().min(1, "상품명을 입력해주세요."),
    depth1: z.number().nullable().refine(val => val && val > 0, "카테고리를 선택해주세요."),
    // brand_id: z.number().min(1, "브랜드를 선택해주세요."),
    brand_id: z.number().nullable().refine(val => val && val > 0, "브랜드를 선택해주세요."),

    product_condition: z.string().min(1, "상품의 컨디션을 선택해주세요."),
    price: z.number().min(1000,"판매가격을 입력해주세요."),
    description_ko: z.string().min(1, "상품 설명을 입력해주세요."),
    image_list: z.array(z.string()).nonempty("상품 사진을 등록해주세요."),
    
    stock_list: z.array(
      z.object({
        color_id: z.number().min(1),
        size_list: z.array(
          z.object({
            size_id: z.number().min(1),
            amount: z.number().min(1)
          })
        ).nonempty() // size_list 빈 배열 허용하지 않음
      })
    ).nonempty() // stock_list 빈 배열 허용하지 않음
    
  })
  .passthrough();

export const changePasswordSchema = z
  .object({
    current_password: z.string(),
    new_password: z
      .string()
      .min(8)
      .max(20)
      .regex(/^(?=.*[a-zA-Z])(?=.*\d)/),
    confirm_password: z.string(),
  })
  .refine((data) => data.new_password === data.confirm_password, {
    message: "비밀번호 재확인",
    path: ["confirm_password"],
  });


// 리뷰 작성
export const reviewSchema = z
  .object({
    rate: z.number().min(1, ""), 
    review_text: z.string().min(1, ""),
  })
  .passthrough();

  // 판매 정책 설정
  export const salesPolicySchema = z 
  .object (
    {
      introduction: z.string().min(1,""),
      // shipping_fee: z.number().min(1, ""), 
      free_shipping_fee: z.number().min(1, ""), 
    }
  )
  .passthrough();

  // 계좌관리
  export const bankAccountSchema = z
  .object({
    account_holder: z.string().min(1, ""),
    bank_cd: z.string().min(1, ""),
    account_number: z.string().min(1, "계좌번호를 입력해주세요."),
  })
  .passthrough();


    